import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "44",
  height: "44",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "44",
      height: "44",
      fill: "#454545",
      class: "background",
      rx: "22"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "m23.556 10.22-.906 2.071h7.506L18.897 23.55l1.553 1.553L31.71 13.844v7.506l2.07-.906V10.221H23.557Z",
      class: "foreground"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-linecap": "square",
      "stroke-miterlimit": "10",
      "stroke-width": "1.294",
      d: "M18.574 14.428h-6.471v6.47m0 4.53v6.47h6.47m4.53 0h6.47v-6.47",
      class: "foreground",
      style: {"fill":"none"}
    }, null, -1)
  ])))
}
export default { render: render }